import * as React from 'react';

export function TrustedDelivery() {
  return (
    <section className="bp-trusted">
      <style>{`
        .bp-trusted {
          padding: 72px 24px;
          background: #fff;
        }
        .bp-trusted-inner {
          max-width: 960px;
          margin: 0 auto;
        }
        .bp-trusted h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          text-align: center;
        }
        .bp-trusted .subtitle {
          font-size: 16px;
          color: #666;
          text-align: center;
          margin: 0 0 40px;
        }
        .bp-trusted-cards {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
        }
        .bp-trusted-card {
          text-align: center;
          background: #fafaf7;
          border-radius: 12px;
          padding: 24px 16px;
          border: 1px solid #eee;
        }
        .bp-trusted-card .card-icon {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: #f0fdf0;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 12px;
        }
        .bp-trusted-card .card-icon i {
          font-size: 20px;
          color: #1EAA25;
        }
        .bp-trusted-card h3 {
          font-size: 15px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 6px;
        }
        .bp-trusted-card p {
          font-size: 13px;
          color: #666;
          line-height: 1.5;
          margin: 0;
        }
        @media (max-width: 768px) {
          .bp-trusted-cards {
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
          }
          .bp-trusted h2 {
            font-size: 24px;
          }
        }
        @media (max-width: 480px) {
          .bp-trusted-cards {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <div className="bp-trusted-inner">
        <h2>Repartidores de confianza</h2>
        <p className="subtitle">Sabemos que en tu barrio la seguridad es prioridad. Nosotros también.</p>

        <div className="bp-trusted-cards">
          <div className="bp-trusted-card">
            <div className="card-icon"><i className="fa fa-id-card" /></div>
            <h3>Preaprobados</h3>
            <p>Cada repartidor pasa por un proceso de verificación antes de hacer entregas.</p>
          </div>
          <div className="bp-trusted-card">
            <div className="card-icon"><i className="fa fa-shield-alt" /></div>
            <h3>Seguros al día</h3>
            <p>Vehículos con seguro vigente y documentación en regla.</p>
          </div>
          <div className="bp-trusted-card">
            <div className="card-icon"><i className="fa fa-user-check" /></div>
            <h3>Identificados</h3>
            <p>Llegan con identificación y datos del pedido para coordinar con la guardia.</p>
          </div>
          <div className="bp-trusted-card">
            <div className="card-icon"><i className="fa fa-route" /></div>
            <h3>Rutas fijas</h3>
            <p>Los mismos repartidores recorren los mismos barrios. Caras conocidas.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
